var _path, _style;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoArtWhiteOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 311,
    height: 324,
    viewBox: "0 0 311 324",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.359 0.193359L117.987 99.2828H0.731018L59.359 0.193359ZM212.892 40.536C212.892 53.4189 206.932 64.7428 197.423 72.1042L212.042 99.4241H124.755V0.193359H172.443C194.725 0.193359 212.892 18.1707 212.892 40.536ZM290.635 99.4241H240.96V49.8786H220.38V0.193359H309.936V49.8786H290.635V99.4241Z",
    stroke: "white",
    strokeWidth: 0.966803,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "ohFdhqAG_0"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    "data-made-with": "vivus-instant"
  }, ".ohFdhqAG_0{stroke-dasharray:1091 1093;stroke-dashoffset:1092;animation:ohFdhqAG_draw_0 7200ms ease-in 0ms infinite,ohFdhqAG_fade 7200ms linear 0ms infinite;}@keyframes ohFdhqAG_draw{100%{stroke-dashoffset:0;}}@keyframes ohFdhqAG_fade{0%{stroke-opacity:1;}94.44444444444444%{stroke-opacity:1;}100%{stroke-opacity:0;}}@keyframes ohFdhqAG_draw_0{11.11111111111111%{stroke-dashoffset: 1092}52.708333333333336%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoArtWhiteOutline);
export default __webpack_public_path__ + "static/media/logo-ART-white-outline.a5575731e52c33e9be9b602e08d5f8cc.svg";
export { ForwardRef as ReactComponent };